import React, {useState, useEffect, useRef, useContext} from 'react';

import AppContext from '../hooks/AppContext'
import ScroolHook from '../hooks/ScroolHook';
import classNames from 'classnames';

import ZonaDetalhe from './ZonaDetalhe'
import Aguardando from './Aguardando'

const ListaZonas = (props) => {

  const { localidadeSelecionadaId ,localidadeSelecionada, zonaESelecionadaId, zonaESelecionada, localVSelecionadoId,localVSelecionado} = useContext(AppContext);   

  const [skeletonShow, setSkeletonShow] = useState(false)

  useEffect(() => { 
    
    //se totalização encontrada desabilita skeleton
    if(props?.sessoesAgrupadas){
      setSkeletonShow(false);
    }

    //se totalização retornou nula do firbase desabilita o skeleton
    if(props?.sessoesAgrupadas===null){
      setTimeout(()=> setSkeletonShow(false),100);
    }

  }, [props?.sessoesAgrupadas]);

  
  useEffect(() => { 
    if( localidadeSelecionada || zonaESelecionada || localVSelecionado){
      setSkeletonShow(true);
    }
    //timeout do skeleton caso não tenha resposta do firebase
    setTimeout(()=> setSkeletonShow(false), 5000);
  }, [ localidadeSelecionada, zonaESelecionada, localVSelecionado]);  

  const renderZonas = () =>{
    return( 
      props?.sessoesAgrupadas?.zonas?.map( item => {
        return <ZonaDetalhe key={item?.nrZona}                                 
                        localidades={item?.localidades}
                        localVotacao={item?.localVotacao}
                        zona={item?.nrZona}
                        secoesLidas={item?.secoesLidas} 
                        secoesNaoLidas={item?.secoesNaoLidas}
                        search={props?.search} 
                        total={item?.totalSecoes} 
                        ocultaLidas={props?.ocultaLidas}  ocultaNLidas={props?.ocultaNLidas} detalhes />
      })
    );
  }

  const renderSkeletons = (num) =>{       
    return(
      Array.from({length: num}, (v, i) => i).map(item =>{                  
        return <ZonaDetalhe key={item} detalhes skeleton/>
      })
    )   
  }

  const wrapContainer = classNames("container-dado bloco-dados gap-vhw scroolable align-items-center",{
    "secoes-container-empty": !props?.sessoesAgrupadas && !skeletonShow,
    "secoes-container-empty flex-wrap align-content-start ": skeletonShow && ! props?.sessoesAgrupadas && (localidadeSelecionadaId || zonaESelecionadaId || localVSelecionadoId),
    "secoes-container flex-wrap align-content-start ": props?.sessoesAgrupadas
  })

  return (
      <div className={wrapContainer}>
            
            {!props?.sessoesAgrupadas?
              localidadeSelecionada || zonaESelecionada || localVSelecionado?
                skeletonShow?                     
                    renderSkeletons(3)                    
                  :
                    <Aguardando/>
                :
                  <div className="container-dado-alt">Selecione pelo menos uma configuração de exibição</div>                     
              :
                <ScroolHook listaDados={props?.sessoesAgrupadas?.zonas}>
                  {renderZonas()}
                </ScroolHook>
            }            
      </div>
  )
}

export default ListaZonas;    

